import React, { FC } from 'react';

import { cn } from '@/shared/libs/utils';

export interface FieldErrorProps {
  error?: string | string[];
  className?: string;
}

export const FieldError: FC<FieldErrorProps> = ({ className, error }) => {
  if (!error) return null;

  const errorMessage = Array.isArray(error) ? error[0] : error;

  return (
    <p className={cn('text-sm font-medium text-destructive', className)}>
      {errorMessage}
    </p>
  );
};
